export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nombre',
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "Responsable",
                    type: 'text',
                    key: 'legal_representative',
                },
                {
                    title: "Teléfono",
                    type: 'text',
                    key: 'phone',
                },
                {
                    title: "E-mail",
                    type: 'text',
                    key: 'email',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}